<template>
  <b-modal
    ref="metadataSearchResult"
    title="Wyszukiwarka metadanych"
    size="lg"
    :hide-footer="true"
    centered
    @hidden="modalHidden"
  >
    <b-tabs tabs v-model="tabIndex">
      <b-tab active title="Lista">
        <b-row>
          <b-col>
            <b-table
              v-if="services.length > 0"
              class="mt-2"
              :fields="fields"
              :items="services"
              bordered
            >
              <template v-slot:cell(details)="row">
                <div class="d-flex">
                  <b-link @click.stop="showDetails(row)" title="Szczegóły">
                    <icon name="list-alt"></icon>
                  </b-link>
                  <b-link
                    class="pl-2"
                    @click.stop="showExtent(row)"
                    title="Pokaż zasięg"
                  >
                    <icon prefix="far" name="square"></icon>
                  </b-link>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="5">
            Elementów na stronie: {{ elementsOnPageStart }} -
            {{ elementsOnPageEnd }} / {{ totalRows }}
          </b-col>
          <b-col cols="7">
            <b-pagination
              ref="pagination"
              align="right"
              :total-rows="totalRows"
              :per-page="pageSize"
              @change="changePage"
              label-first-page="Pierwsza strona"
              label-prev-page="Poprzednia strona"
              label-next-page="Następna strona"
              label-last-page="Ostatnia strona"
              label-page="Strona"
              aria-label="Paginacja"
            >
            </b-pagination>
          </b-col>
        </b-row>
        <loading-overlay
          :active.sync="submitting"
          :is-full-page="false"
        ></loading-overlay>
      </b-tab>
      <b-tab title="Szczegóły" :disabled="!currentItemDetails">
        <metadata-search-result-details
          v-if="currentItemDetails"
          v-model="currentItemDetails"
        ></metadata-search-result-details>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { Api as ServicesApi } from '../api/api-uslugi-mapowe.js';
import MetadataSearchResultDetails from './MetadataSearchResultDetails';
import { METADATA_EXTENT_LAYER_ADD_OR_CHANGE } from '../store/actions.type';
import MetadataFormatter from '../models/MetadataFormatter.js';
import LoadingOverlay from 'vue-loading-overlay';

export default {
  name: 'MetadataSearchResult',
  components: {
    MetadataSearchResultDetails,
    LoadingOverlay
  },
  data() {
    return {
      services: [],
      fields: [
        {
          key: 'title',
          label: 'Tytuł'
        },
        {
          key: 'details',
          label: 'Szczegóły'
        }
      ],
      tabIndex: 0,
      currentItemDetails: null,
      key: null,
      value: null,
      url: null,
      totalRows: null,
      submitting: false,
      currentPage: 1,
      pageSize: 5,
      lowerCorner: null,
      upperCorner: null
    };
  },
  computed: {
    elementsOnPageStart() {
      return (
        (this.currentPage - 1) * this.pageSize + (this.services.length ? 1 : 0)
      );
    },
    elementsOnPageEnd() {
      return (this.currentPage - 1) * this.pageSize + this.services.length;
    }
  },
  methods: {
    show(services, key, value, url, totalRows, lowerCorner, upperCorner) {
      this.services = services;
      this.value = value;
      this.key = key;
      this.url = url;
      this.totalRows = totalRows;
      this.lowerCorner = lowerCorner;
      this.upperCorner = upperCorner;
      this.$refs.metadataSearchResult.show();
    },
    showDetails(row) {
      this.currentItemDetails = (row.item || {}).data;
      this.$nextTick(function() {
        this.tabIndex = 1;
      });
    },
    showExtent(row) {
      const minX = +row.item.westBoundLongitude;
      const minY = +row.item.southBoundLatitude;
      const maxX = +row.item.eastBoundLongitude;
      const maxY = +row.item.northBoundLatitude;

      if (!isNaN(minX) && !isNaN(minY) && !isNaN(maxX) && !isNaN(maxY)) {
        this.$store.dispatch(METADATA_EXTENT_LAYER_ADD_OR_CHANGE, [
          minX,
          minY,
          maxX,
          maxY
        ]);
        this.$refs.metadataSearchResult.hide();
      }
    },
    modalHidden() {
      this.tabIndex = 0;
    },
    async changePage() {
      try {
        this.submitting = true;
        const api = new ServicesApi();
        const pageNumber = this.$refs.pagination.currentPage;
        const response = await api.getCswRecords({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          url: this.url,
          filter_key: this.key,
          filter_value: this.value,
          items_per_page: 5,
          page_number: pageNumber,
          lower_corner: this.lowerCorner,
          upper_corner: this.upperCorner
        });
        this.currentPage = pageNumber;

        if (
          response.body.services['csw:GetRecordsResponse'] &&
          response.body.services['csw:GetRecordsResponse']['csw:SearchResults']
        ) {
          if (
            response.body.services['csw:GetRecordsResponse'][
              'csw:SearchResults'
            ]['@numberOfRecordsReturned'] > 0
          ) {
            this.totalRows = +response.body.services['csw:GetRecordsResponse'][
              'csw:SearchResults'
            ]['@numberOfRecordsMatched'];
            const searchResults =
              response.body.services['csw:GetRecordsResponse'][
                'csw:SearchResults'
              ];
            const metadataFormatter = new MetadataFormatter(searchResults);
            this.services = metadataFormatter.format();
          } else {
            this.services = [];
          }
        } else {
          this.$notify({
            type: 'error',
            title: 'Uwaga!',
            text: 'Pobranie metadanych nie powiodło się.',
            duration: 2000
          });
        }
      } catch (exception) {
        this.$notify({
          type: 'error',
          title: 'Uwaga!',
          text: 'Pobranie metadanych nie powiodło się.',
          duration: 2000
        });
      } finally {
        this.submitting = false;
      }
    }
  },
  watch: {
    tabIndex(value) {
      if (!value) {
        this.currentItemDetails = null;
      }
    }
  }
};
</script>
